<template>
    <div class="wing_add">
        <a></a>
    </div>
</template>

<script>
    export default {
        name:"AddBtn"
    }
</script>